<template>
  <div>
    <p
      v-if="htmlPageVersion.notUpdated"
      style="font-size: 12px"
      class="error--text pt-2 ml-5"
    >
      変更が反映されていません
    </p>
    <template v-if="htmlPageVersion.deliveryRate === 1">
      <v-chip
        class="mt-1 mr-3 ml-5 float-right font-weight-bold"
        x-small
        label
        color="success"
      >
        公開
      </v-chip>
    </template>
    <template v-else>
      <v-chip
        class="mt-1 mr-3 ml-5 float-right font-weight-bold"
        x-small
        label
        color="warning"
      >
        非公開
      </v-chip>
    </template>
    <v-text-field
      v-model="htmlPageVersionName"
      label="バージョン名"
      style="width: 130px"
      class="ml-5 mt-4 pt-0"
      required
      @input="inputted()"
    ></v-text-field>
    <div class="d-flex" justify="center" style="width: 100%">
      <v-btn
        small
        class="ml-4 mb-2"
        color="primary"
        @click="update(htmlPageVersion)"
        >更新</v-btn
      >
      <v-btn
        small
        class="ml-1 mb-2"
        color="success"
        @click="publication(htmlPageVersion.id)"
        >公開</v-btn
      >
      <v-menu bottom left>
        <template v-slot:activator="{ on }">
          <v-btn class="mr-2 ml-auto" dark icon v-on="on">
            <v-icon color="grey"> mdi-dots-horizontal </v-icon>
          </v-btn>
        </template>

        <v-list class="pa-0">
          <v-list-item
            class="list-item"
            @click="duplicateHtmlPageVersion(htmlPageVersion.id)"
          >
            <v-list-item-content>
              <v-list-item-title>複製</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="list-item" @click="destroy(htmlPageVersion.id)">
            <v-list-item-content>
              <v-list-item-title>削除</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    htmlPageVersion: {
      type: Object,
      required: true
    }
  },
  computed: {
    htmlPageVersionName: {
      get: function () {
        return this.htmlPageVersion.name
      },
      set: function (value) {
        const payload = {
          versionId: this.htmlPageVersion.id,
          name: value
        }
        this.$store.commit('UPDATE_HTML_PAGE_VERSION_NAME', payload)
      }
    }
  },
  methods: {
    inputted () {
      this.$emit('not-updated-html-page-version', this.htmlPageVersion.id)
    },
    publication (html_page_version_id) {
      this.$store.dispatch('LoaderStore/displayLoader')
      axios
        .patch(`/api/html_page_versions/${html_page_version_id}/publication`)
        .then(
          () => {
            const payload = {
              status: 200,
              message: 'バージョンを公開しました'
            }
            this.$store.commit('UPDATE_HTML_PAGE_VERSION_DELIVERY_RATE', {
              versionId: html_page_version_id
            })
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.message
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
        .finally(() => {
          this.$store.dispatch('LoaderStore/hideLoader')
        })
    },
    update (htmlPageVersion) {
      this.$store.dispatch('LoaderStore/displayLoader')
      const query = {
        htmlPageVersion: {
          name: htmlPageVersion.name,
          headContent: htmlPageVersion.headContent,
          bodyContent: htmlPageVersion.bodyContent,
          cssContent: htmlPageVersion.cssContent
        }
      }
      axios
        .patch(`/api/html_page_versions/${htmlPageVersion.id}`, query)
        .then(
          () => {
            this.notUpdated = false
            const payload = {
              status: 200,
              message: 'HTMLページを更新しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
            this.$store.commit('CHANGE_HTML_PAGE_VERSION_NOT_UPDATED', {
              htmlPageVersionId: htmlPageVersion.id
            })
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.message
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
        .finally(() => {
          this.$store.dispatch('LoaderStore/hideLoader')
        })
    },
    destroy (htmlPageVersionId) {
      this.$emit('destroy-html-page-version', htmlPageVersionId)
    },
    duplicateHtmlPageVersion (htmlPageVersionId) {
      this.$emit('duplicate-html-page-version', htmlPageVersionId)
    }
  }
}
</script>
<style scoped>
.list-item:hover {
  background: #f7f7f7;
  cursor: pointer;
}
</style>
